export default __webpack_public_path__ + "static/media/linke.7d42da69.svg";